import React, { ReactNode } from 'react';

import { InfoBox } from '../../../../shared/components/ui-components/InfoBox/InfoBox';
import { TimezoneSection } from './sections/TimezoneSection/TimezoneSection';
import { ChallengeDatesSection } from './sections/ChallengeDatesSection/ChallengeDatesSection';
import { RegistrationDatesSection } from './sections/RegistrationDatesSection/RegistrationDatesSection';
import { MeasurementDatesSection } from './sections/MeasurementDatesSection/MeasurementDatesSection';
import { Mode } from '../../../../general-types';
import { useImportantDatesForm } from '../../../hooks/useImportantDatesForm';

type ImportantDatesFromProps = {
  mode: Mode;
  headerActions?: ReactNode;
};

/**
 * Important Dates Widget - manages challenge date configuration
 *
 * @mode Auto-calculated fields behavior:
 * - EDIT mode: values are calculated from dependent fields and override form values
 * - VIEW mode: values are taken from form state (saved data from backend)
 * This ensures VIEW mode displays actual saved data, not recalculated values.
 *
 * @see https://lifebasellc.atlassian.net/wiki/spaces/DEV/pages/648544257/Challenge+create+and+edit+functionality#2.-Important-Dates
 */
export const ImportantDatesFrom = ({ mode, headerActions }: ImportantDatesFromProps) => {
  const {
    challengeMinStartDate,
    challengeMaxStartDate,
    challengeMinEndDate,
    registrationMaxStartDate,
  } = useImportantDatesForm(mode);

  return (
    <InfoBox title="Important Dates" icon={headerActions} customContentPadding>
      <TimezoneSection mode={mode} />
      <ChallengeDatesSection
        mode={mode}
        challengeMinStartDate={challengeMinStartDate}
        challengeMaxStartDate={challengeMaxStartDate}
        challengeMinEndDate={challengeMinEndDate}
      />
      <RegistrationDatesSection
        mode={mode}
        registrationMaxStartDate={registrationMaxStartDate}
      />
      <MeasurementDatesSection />
    </InfoBox>
  );
};
